// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className=" text-white p-6">
      <div className="container mx-auto text-center">
        <p className="text-sm">&copy; {new Date().getFullYear()} Galimberti Rappresentanze. All rights reserved.</p>
        <div className="mt-2">
          <a href="https://www.iubenda.com/privacy-policy/53277442" className="text-blue-400 hover:underline mx-2">
            Privacy Policy
          </a>
          <a href="https://www.iubenda.com/termini-e-condizioni/53277442" className="text-blue-400 hover:underline mx-2">
            Terms of Service
          </a>
          <a href="https://www.iubenda.com/privacy-policy/53277442/cookie-policy" className="text-blue-400 hover:underline mx-2">
            Cookie policy
          </a>
        </div>
        <div className="mt-4 flex justify-center space-x-4">
          <a href="https://www.instagram.com/galimbertirappresentanze/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram text-pink-400 text-xl hover:text-pink-600"></i>
          </a>
          {//<a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            //<i className="fab fa-linkedin text-blue-300 text-xl hover:text-blue-500"></i>
          //</a> 
          }
        </div>
      </div>
    </footer>
  );
};

export default Footer;
